import { useEffect, useState } from 'react';
import Mustache from 'mustache';
import { useReduxState } from 'hooks';

import type { Course, CourseCompletion, User } from 'shared-types';

interface Props {
  course: Pick<Course, 'customAttributes' | 'title'>;
  courseCompletion: Pick<
    CourseCompletion,
    | 'completionDate'
    | 'courseTitle'
    | 'expirationDate'
    | 'tasksPercentage'
    | 'tasksPoints'
  > &
    Partial<
      Pick<
        CourseCompletion,
        | 'courseWorkload'
        | 'id'
        | 'inactive'
        | 'isManuallySet'
        | 'readingProgress'
        | 'status'
        | 'tasksProgress'
        | 'videoProgress'
      >
    >;
  showEmailContent?: boolean;
  targetUser: Pick<
    User,
    'customAttributes' | 'firstName' | 'lastName' | 'email' | 'username'
  >;
}

const CourseCompletionCustomContent = ({
  course,
  courseCompletion,
  showEmailContent,
  targetUser
}: Props) => {
  const {
    serverConfig: {
      courseCompletionCustomContent,
      courseCompletionEmailCustomContent
    }
  } = useReduxState();

  const [html, setHtml] = useState('');

  useEffect(() => {
    try {
      const customContent = showEmailContent
        ? courseCompletionEmailCustomContent
        : courseCompletionCustomContent;

      const parsedCompletionDate = new Date(courseCompletion.completionDate);
      const parsedExpirationDate = new Date(courseCompletion.expirationDate);

      const templateVariables = {
        course,
        completionDate: {
          year: parsedCompletionDate.getFullYear(),
          month: Number(parsedCompletionDate.getMonth()) + 1,
          day: parsedCompletionDate.getDate()
        },
        expirationDate: courseCompletion.expirationDate
          ? {
              year: parsedExpirationDate.getFullYear(),
              month: Number(parsedExpirationDate.getMonth()) + 1,
              day: parsedExpirationDate.getDate()
            }
          : { year: null, month: null, day: null },
        tasksPercentage: courseCompletion.tasksPercentage,
        tasksPoints: courseCompletion.tasksPoints,
        user: targetUser
      };

      const html = Mustache.render(customContent, templateVariables);
      setHtml(html);
    } catch (error) {
      setHtml('error');
    }
  }, [course, courseCompletion, showEmailContent, targetUser]);

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: html
      }}
    />
  );
};

export default CourseCompletionCustomContent;
